import { render, staticRenderFns } from "./CardArboAdmin.vue?vue&type=template&id=00a409f8&"
import script from "./CardArboAdmin.vue?vue&type=script&lang=js&"
export * from "./CardArboAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports